/** Extend this list in code when adding new portfolio categories. */
export const PROJECT_CATEGORIES = ['Software', 'Hardware', 'CAD', 'Other'] as const;

export type ProjectCategoryId = (typeof PROJECT_CATEGORIES)[number];
